<script>
import { dispatch, get } from 'vuex-pathify';
import { debounce } from 'throttle-debounce';
import inputTypeOptions from '@/modules/document/_field-types/inputs';
import dataTypeOptions from '@/modules/document/_field-types/data';
import presentationTypeOptions from '@/modules/document/_field-types/presentation';
import ValueField from '@/modules/document/_component/fields/ValueField.vue';
import DataValue from '@/modules/document/_component/values/DataValue.vue';

export default {
    components: {
        ValueField,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            inputTypeOptions,
            dataTypeOptions,
            presentationTypeOptions,
        };
    },
    computed: {
        view: get('document/view'),
        component() {
            if (this.field.type === 'data') {
                return DataValue;
            }

            if (this.dataType) {
                if (this.view === 'preview') {
                    return this.dataType.valueComponent ?? ValueField;
                }

                return this.dataType.component ?? ValueField;
            }

            return ValueField;
        },
        dataType() {
            if (this.field.type === 'input' && this.field.options?.input_type) {
                return this.inputTypeOptions.find(option => option.value === this.field.options?.input_type);
            }

            if (this.field.type === 'presentation' && this.field.options?.presentation_type) {
                return this.presentationTypeOptions.find(option => option.value === this.field.options?.presentation_type);
            }

            return {};
        },
        value: {
            get() {
                return this.field.value;
            },
            set(value) {
                this.saveInput(this.field, value);
            },
        },
    },
    methods: {
        saveInput: debounce(500, (field, value) => {
            dispatch('document/updateField', {
                field: {
                    ...field,
                    value,
                },
            });
        }),
    },
};
</script>

<template>
    <component
        :is="component"
        v-model="value"
        :field="field"
    />
</template>

<style
    scoped
    lang="scss"
>

</style>
